export const allCandles = [
  {
    id: "AtC1",
    name: "Iced Lemon Pound Cake",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dwad70deb6/crop/026467605_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "Just Added!",
    category1: "3-Wick Candle",
    Amount: 26.5,
    Rating: 55,
    desc: "What it smells like: standing in the middle of a lilac field on a cool spring morning. Fragrance notes: lilac bouquets, dewy greens and soft spring air.",
    height: 220,
    width: 200,
  },
  {
    id: "AtC2",
    name: "Raspberry Mimosa",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw70e74edd/crop/026480790_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "Just Added!",
    category1: "Single Wick Candle",
    Amount: 15.5,
    Rating: 9,
    desc: "What it smells like: standing in the middle of a lilac field on a cool spring morning. Fragrance notes: lilac bouquets, dewy greens and soft spring air.",
    height: 220,
    width: 200,
  },
  {
    id: "AtC3",
    name: "Strawberry Pound Cake",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dwc7392bfd/crop/026458600_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "New!",
    category1: "3-Wick Candle",
    Amount: 24.5,
    Rating: 13,
    desc: "What it smells like: standing in the middle of a lilac field on a cool spring morning. Fragrance notes: lilac bouquets, dewy greens and soft spring air.",
    height: 220,
    width: 200,
  },
  {
    id: "AtC4",
    name: "Honeysuckle & Peach Spritz",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw58ab0cad/crop/026480467_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "New!",
    category1: "Single Wick Candle",
    Amount: 15.5,
    Rating: 4,
    desc: "What it smells like: standing in the middle of a lilac field on a cool spring morning. Fragrance notes: lilac bouquets, dewy greens and soft spring air.",
    height: 220,
    width: 200,
  },
  {
    id: "AtC5",
    name: "Coastal Watermelon",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw9f23f750/crop/026482403_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "Just Added!",
    category1: "Single Wick Candle",
    Amount: 15.5,
    Rating: 2,
    desc: "What it smells like: standing in the middle of a lilac field on a cool spring morning. Fragrance notes: lilac bouquets, dewy greens and soft spring air.",
    height: 220,
    width: 200,
  },
  {
    id: "AtC6",
    name: "Fresh Cut Lilacs",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dwc9985836/crop/026458601_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "New Fragrance",
    category1: "3-Wick Candle",
    Amount: 24.5,
    Rating: 9,
    desc: "What it smells like: standing in the middle of a lilac field on a cool spring morning. Fragrance notes: lilac bouquets, dewy greens and soft spring air.",
    height: 220,
    width: 200,
  },
  {
    id: "AtC7",
    name: "Japanese Cherry Blossom",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw2fb6a62e/crop/026468838_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "New Fragrance",
    category1: "Single Wick Candle",
    Amount: 15.4,
    Rating: 4,
    desc: "What it smells like: standing in the middle of a lilac field on a cool spring morning. Fragrance notes: lilac bouquets, dewy greens and soft spring air.",
    height: 220,
    width: 200,
  },
  {
    id: "AtC8",
    name: "Waikiki Beach Coconu",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw7ba36a12/hires/026441623_alt_1.jpg?sh=413&yocs=o_s_",
    category: "Online Exclusive",
    category1: "3-Wick Candle",
    Amount: 26.5,
    Rating: 27,
    desc: "What it smells like: standing in the middle of a lilac field on a cool spring morning. Fragrance notes: lilac bouquets, dewy greens and soft spring air.",
    height: 220,
    width: 200,
  },
  {
    id: "AtC9",
    name: "Water Globe Pineapple",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw49cac0a3/crop/026413479_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "Online Exclusive",
    category1: "3-Wick Candle Holder",
    Amount: 37,
    Rating: 33,
    desc: "What it smells like: standing in the middle of a lilac field on a cool spring morning. Fragrance notes: lilac bouquets, dewy greens and soft spring air.",
    height: 220,
    width: 200,
  },
  {
    id: "AtC10",
    name: "Pink Pineapple Sunrise",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw3a3f2729/crop/026448739_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "Online Exclusive",
    category1: "Single Wick Candle",
    Amount: 15.5,
    Rating: 6,
    desc: "What it smells like: standing in the middle of a lilac field on a cool spring morning. Fragrance notes: lilac bouquets, dewy greens and soft spring air.",
    height: 220,
    width: 200,
  },
  {
    id: "AtC11",
    name: "The Perfect Summer",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw02c8940e/crop/026517154_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "Online Exclusive",
    category1: "Single Wick Candle",
    Amount: 15.5,
    Rating: 5,
    desc: "What it smells like: standing in the middle of a lilac field on a cool spring morning. Fragrance notes: lilac bouquets, dewy greens and soft spring air.",
    height: 220,
    width: 200,
  },
  {
    id: "AtC12",
    name: "Iced Lemon Pound Cake",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw536b669c/crop/026480791_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "New!",
    category1: "Single Wick Candle",
    Amount: 15.5,
    Rating: 19,
    desc: "What it smells like: standing in the middle of a lilac field on a cool spring morning. Fragrance notes: lilac bouquets, dewy greens and soft spring air.",
    height: 220,
    width: 200,
  },
  {
    id: "AtC13",
    name: "Strawberry Pound Cake",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dwbe0e4c51/crop/026437364_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "New!",
    category1: "Single Wick Candle",
    Amount: 15.5,
    Rating: 36,
    desc: "What it smells like: standing in the middle of a lilac field on a cool spring morning. Fragrance notes: lilac bouquets, dewy greens and soft spring air.",
    height: 220,
    width: 200,
  },
  {
    id: "AtC14",
    name: "Coconut Colada",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw53960c90/crop/026517152_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "Just Added!",
    category1: "Single Wick Candle",
    Amount: 15.5,
    Rating: 4,
    desc: "What it smells like: standing in the middle of a lilac field on a cool spring morning. Fragrance notes: lilac bouquets, dewy greens and soft spring air.",
    height: 220,
    width: 200,
  },
  {
    id: "AtC15",
    name: "Warm Ocean Breeze",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw7b4966c0/hires/026448182_alt_1.jpg?sh=471&yocs=o_s_",
    category: "Just Added!",
    category1: "Single Wick Candle",
    Amount: 15.5,
    Rating: 4,
    desc: "What it smells like: standing in the middle of a lilac field on a cool spring morning. Fragrance notes: lilac bouquets, dewy greens and soft spring air.",
    height: 220,
    width: 200,
  },
  {
    id: "AtC16",
    name: "Water Globe Flamingo",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw3fc182d8/crop/026413477_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "Online Exclusive",
    category1: "3-Wick Candle Holder",
    Amount: 34.47,
    Rating: 25,
    desc: "What it smells like: standing in the middle of a lilac field on a cool spring morning. Fragrance notes: lilac bouquets, dewy greens and soft spring air.",
    height: 220,
    width: 200,
  },
  {
    id: "AtC17",
    name: "Pink Lemonade",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dwf1c8c3fe/hires/026458610.jpg?sh=471&yocs=o_s_",
    category: "Online Exclusive",
    category1: "3-Wick Candle",
    Amount: 26.5,
    Rating: 4,
    desc: "What it smells like: standing in the middle of a lilac field on a cool spring morning. Fragrance notes: lilac bouquets, dewy greens and soft spring air.",
    height: 220,
    width: 200,
  },
  {
    id: "AtC18",
    name: "Waikiki Beach Coconut",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dwf8634b56/hires/026448183.jpg?sh=471&yocs=o_s_",
    category: "New!",
    category1: "Single Wick Candle",
    Amount: 15.5,
    Rating: 1,
    desc: "What it smells like: standing in the middle of a lilac field on a cool spring morning. Fragrance notes: lilac bouquets, dewy greens and soft spring air.",
    height: 220,
    width: 200,
  },
  {
    id: "AtC19",
    name: "Passionfruit & Banana Flower",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw81b12678/hires/026448192.jpg?sh=471&yocs=o_s_",
    category: "Just Added!",
    category1: "Single Wick Candle",
    Amount: 15.5,
    Rating: 11,
    desc: "What it smells like: standing in the middle of a lilac field on a cool spring morning. Fragrance notes: lilac bouquets, dewy greens and soft spring air.",
    height: 220,
    width: 200,
  },
  {
    id: "AtC20",
    name: "Champagne Toast",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw232d9fa8/crop/026459581_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "New!",
    category1: "3-Wick Candle",
    Amount: 26.5,
    Rating: 20,
    desc: "What it smells like: standing in the middle of a lilac field on a cool spring morning. Fragrance notes: lilac bouquets, dewy greens and soft spring air.",
    height: 220,
    width: 200,
  },
];

export const wallFlowers = [
  {
    id: "AtWF1",
    name: "Laundry Day",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw3022bdd5/crop/026397324_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "New!",
    category1: "Wallflowers Fragrance Refill",
    Amount: 7.5,
    Rating: 27,
    desc: "What it smells like: standing in the middle of a lilac field on a cool spring morning. Fragrance notes: lilac bouquets, dewy greens and soft spring air.",
    height: 350,
    width: 190,
  },
  {
    id: "AtWF2",
    name: "Waikiki Beach Coconut",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw412c476c/crop/026399185_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "New Fragrance!",
    category1: "Wallflowers Fragrance Refill",
    Amount: 7.5,
    Rating: 3,
    desc: "What it smells like: standing in the middle of a lilac field on a cool spring morning. Fragrance notes: lilac bouquets, dewy greens and soft spring air.",
    height: 350,
    width: 190,
  },
  {
    id: "AtWF3",
    name: "Eucalyptus Spearmint",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dwf1c3d3c5/crop/026397334_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "New!",
    category1: "Wallflowers Fragrance Refill",
    Amount: 7.5,
    Rating: 11,
    desc: "What it smells like: standing in the middle of a lilac field on a cool spring morning. Fragrance notes: lilac bouquets, dewy greens and soft spring air.",
    height: 350,
    width: 190,
  },
  {
    id: "AtWF4",
    name: "Salted Butterscotch & Vanilla",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw3fabd454/crop/026400285_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "New Fragrance!",
    category1: "Wallflowers Fragrance Refill",
    Amount: 7.5,
    Rating: 30,
    desc: "What it smells like: standing in the middle of a lilac field on a cool spring morning. Fragrance notes: lilac bouquets, dewy greens and soft spring air.",
    height: 350,
    width: 190,
  },
  {
    id: "AtWF5",
    name: "Fresh Sheets",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw08d8480a/crop/026438467_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "New!",
    category1: "Wallflowers Fragrance Refill",
    Amount: 7.5,
    Rating: 24,
    desc: "What it smells like: standing in the middle of a lilac field on a cool spring morning. Fragrance notes: lilac bouquets, dewy greens and soft spring air.",
    height: 350,
    width: 190,
  },
  {
    id: "AtWF6",
    name: "Strawberry Pound Cake",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dwbc8dbe3b/crop/026394689_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "New Fragrance!",
    category1: "Wallflowers Fragrance Refill",
    Amount: 7.5,
    Rating: 24,
    desc: "What it smells like: standing in the middle of a lilac field on a cool spring morning. Fragrance notes: lilac bouquets, dewy greens and soft spring air.",
    height: 350,
    width: 190,
  },
  {
    id: "AtWF7",
    name: "Navy Wallflowers Scent Control™",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw911c291a/crop/026273224_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "New Fragrance!",
    category1: "Wallflowers Fragrance Refill",
    Amount: 12.5,
    Rating: 62,
    desc: "What it smells like: standing in the middle of a lilac field on a cool spring morning. Fragrance notes: lilac bouquets, dewy greens and soft spring air.",
    height: 350,
    width: 190,
  },
  {
    id: "AtWF8",
    name: "White Wallflowers Scent Control™",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dwdd602de9/crop/026194284_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "New!",
    category1: "Wallflowers Fragrance Refill",
    Amount: 12.5,
    Rating: 85,
    desc: "What it smells like: standing in the middle of a lilac field on a cool spring morning. Fragrance notes: lilac bouquets, dewy greens and soft spring air.",
    height: 350,
    width: 190,
  },
  {
    id: "AtWF9",
    name: "Lavender Vanilla",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw93fdcecf/crop/026412381_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "New!",
    category1: "Wallflowers Fragrance Refill",
    Amount: 14.5,
    Rating: 9,
    desc: "What it smells like: standing in the middle of a lilac field on a cool spring morning. Fragrance notes: lilac bouquets, dewy greens and soft spring air.",
    height: 350,
    width: 190,
  },
  {
    id: "AtWF10",
    name: "Fresh Cotton",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dwca05d7f2/crop/026412390_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "New Fragrance!",
    category1: "Wallflowers Fragrance Refill",
    Amount: 14.5,
    Rating: 3,
    desc: "What it smells like: standing in the middle of a lilac field on a cool spring morning. Fragrance notes: lilac bouquets, dewy greens and soft spring air.",
    height: 350,
    width: 190,
  },
  {
    id: "AtWF11",
    name: "Kitchen Lemon",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw6b251aef/crop/026412414_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "New!",
    category1: "Wallflowers Fragrance Refill",
    Amount: 14.5,
    Rating: 21,
    desc: "What it smells like: standing in the middle of a lilac field on a cool spring morning. Fragrance notes: lilac bouquets, dewy greens and soft spring air.",
    height: 350,
    width: 190,
  },
  {
    id: "AtWF12",
    name: "White Tea & Sage",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw451170b1/crop/026397340_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "New Fragrance!",
    category1: "Wallflowers Fragrance Refill",
    Amount: 7.5,
    Rating: 12,
    desc: "What it smells like: standing in the middle of a lilac field on a cool spring morning. Fragrance notes: lilac bouquets, dewy greens and soft spring air.",
    height: 350,
    width: 190,
  },
  {
    id: "AtWF13",
    name: "Limoncello",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw43091280/crop/026394687_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "",
    category1: "Wallflowers Fragrance Refill",
    Amount: 7.5,
    Rating: 41,
    desc: "What it smells like: standing in the middle of a lilac field on a cool spring morning. Fragrance notes: lilac bouquets, dewy greens and soft spring air.",
    height: 350,
    width: 190,
  },
  {
    id: "AtWF14",
    name: "Saltwater Breeze",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dwdc2eabcb/crop/026465831_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "",
    category1: "Wallflowers Fragrance Refill",
    Amount: 7.5,
    Rating: 14,
    desc: "What it smells like: standing in the middle of a lilac field on a cool spring morning. Fragrance notes: lilac bouquets, dewy greens and soft spring air.",
    height: 350,
    width: 190,
  },
  {
    id: "AtWF15",
    name: "Watermelon Lemonade",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw2d401023/crop/026394688_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "",
    category1: "Wallflowers Fragrance Refill",
    Amount: 7.5,
    Rating: 6,
    desc: "What it smells like: standing in the middle of a lilac field on a cool spring morning. Fragrance notes: lilac bouquets, dewy greens and soft spring air.",
    height: 350,
    width: 190,
  },
  {
    id: "AtWF16",
    name: "Bee Buddies",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dwe6986ee5/crop/026444376_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "",
    category1: "Wallflowers Fragrance Refill",
    Amount: 14.5,
    Rating: 3,
    desc: "What it smells like: standing in the middle of a lilac field on a cool spring morning. Fragrance notes: lilac bouquets, dewy greens and soft spring air.",
    height: 350,
    width: 190,
  },
  {
    id: "AtWF17",
    name: "Fresh Cut Lilacs",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw00a13f42/crop/026412393_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "",
    category1: "Wallflowers Fragrance Refill",
    Amount: 14.5,
    Rating: 11,
    desc: "What it smells like: standing in the middle of a lilac field on a cool spring morning. Fragrance notes: lilac bouquets, dewy greens and soft spring air.",
    height: 350,
    width: 190,
  },
  {
    id: "AtWF18",
    name: "Island Margarita",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw82e3c538/crop/026399184_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "",
    category1: "Wallflowers Fragrance Refill",
    Amount: 7.5,
    Rating: 7,
    desc: "What it smells like: standing in the middle of a lilac field on a cool spring morning. Fragrance notes: lilac bouquets, dewy greens and soft spring air.",
    height: 350,
    width: 190,
  },
];

export const roomSprays = [
  {
    id: "AtRS1",
    name: "Mahogany Teakwood",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dwd209a833/crop/026302252_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "",
    category1: "Concentrated Room Spray",
    Amount: 8.5,
    Rating: 41,
    desc: "What it smells like: standing in the middle of a lilac field on a cool spring morning. Fragrance notes: lilac bouquets, dewy greens and soft spring air.",
    height: 400,
    width: 150,
  },
  {
    id: "AtRS2",
    name: "Limoncello",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw488a5454/crop/026302259_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "New!",
    category1: "Concentrated Room Spray",
    Amount: 8.5,
    Rating: 24,
    desc: "What it smells like: standing in the middle of a lilac field on a cool spring morning. Fragrance notes: lilac bouquets, dewy greens and soft spring air.",
    height: 400,
    width: 150,
  },
  {
    id: "AtRS3",
    name: "Iced Dragonfruit Tea",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw280a985a/crop/026501106_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "",
    category1: "Concentrated Room Spray",
    Amount: 8.5,
    Rating: 1,
    desc: "What it smells like: standing in the middle of a lilac field on a cool spring morning. Fragrance notes: lilac bouquets, dewy greens and soft spring air.",
    height: 400,
    width: 150,
  },
  {
    id: "AtRS4",
    name: "Ocean Driftwood",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dwbe0d1b45/crop/026501105_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "New!",
    category1: "Concentrated Room Spray",
    Amount: 8.5,
    Rating: 21,
    desc: "What it smells like: standing in the middle of a lilac field on a cool spring morning. Fragrance notes: lilac bouquets, dewy greens and soft spring air.",
    height: 400,
    width: 150,
  },
  {
    id: "AtRS5",
    name: "Fresh Cut Lilacs",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw026dbe98/crop/026410608_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "New!",
    category1: "Concentrated Room Spray",
    Amount: 8.5,
    Rating: 14,
    desc: "What it smells like: standing in the middle of a lilac field on a cool spring morning. Fragrance notes: lilac bouquets, dewy greens and soft spring air.",
    height: 400,
    width: 150,
  },
  {
    id: "AtRS6",
    name: "Eucalyptus Spearmint",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw5cb847c3/crop/026397112_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "New!",
    category1: "Concentrated Room Spray",
    Amount: 8.5,
    Rating: 1,
    desc: "What it smells like: standing in the middle of a lilac field on a cool spring morning. Fragrance notes: lilac bouquets, dewy greens and soft spring air.",
    height: 400,
    width: 150,
  },
  {
    id: "AtRS7",
    name: "Vanilla Patchouli",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw59522c25/crop/026397114_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "New Fragrance!",
    category1: "Concentrated Room Spray",
    Amount: 8.5,
    Rating: 11,
    desc: "What it smells like: standing in the middle of a lilac field on a cool spring morning. Fragrance notes: lilac bouquets, dewy greens and soft spring air.",
    height: 400,
    width: 150,
  },
  {
    id: "AtRS8",
    name: "Waikiki Beach Coconut",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw0b3cf307/crop/026454382_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "New!",
    category1: "Concentrated Room Spray",
    Amount: 8.5,
    Rating: 1,
    desc: "What it smells like: standing in the middle of a lilac field on a cool spring morning. Fragrance notes: lilac bouquets, dewy greens and soft spring air.",
    height: 400,
    width: 150,
  },
  {
    id: "AtRS9",
    name: "Laundry Day",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw41dfae81/crop/026438912_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "",
    category1: "Concentrated Room Spray",
    Amount: 8.5,
    Rating: 14,
    desc: "What it smells like: standing in the middle of a lilac field on a cool spring morning. Fragrance notes: lilac bouquets, dewy greens and soft spring air.",
    height: 400,
    width: 150,
  },
  {
    id: "AtRS10",
    name: "Warm Ocean Breeze",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dweab96098/crop/026454385_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "New Fragrance!",
    category1: "Concentrated Room Spray",
    Amount: 8.5,
    Rating: 14,
    desc: "What it smells like: standing in the middle of a lilac field on a cool spring morning. Fragrance notes: lilac bouquets, dewy greens and soft spring air.",
    height: 400,
    width: 150,
  },
  {
    id: "AtRS11",
    name: "Mango Mai Tai",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw0e563d1e/crop/026454381_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "",
    category1: "Concentrated Room Spray",
    Amount: 8.5,
    Rating: 1,
    desc: "What it smells like: standing in the middle of a lilac field on a cool spring morning. Fragrance notes: lilac bouquets, dewy greens and soft spring air.",
    height: 400,
    width: 150,
  },
  {
    id: "AtRS12",
    name: "Island Margarita",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dwbce4b113/crop/026454383_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "New Fragrance!",
    category1: "Concentrated Room Spray",
    Amount: 8.5,
    Rating: 11,
    desc: "What it smells like: standing in the middle of a lilac field on a cool spring morning. Fragrance notes: lilac bouquets, dewy greens and soft spring air.",
    height: 400,
    width: 150,
  },
  {
    id: "AtRS13",
    name: "Coconut Sandalwood",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dwfc594c6f/crop/026410616_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "",
    category1: "Concentrated Room Spray",
    Amount: 8.5,
    Rating: 7,
    desc: "What it smells like: standing in the middle of a lilac field on a cool spring morning. Fragrance notes: lilac bouquets, dewy greens and soft spring air.",
    height: 400,
    width: 150,
  },
  {
    id: "AtRS14",
    name: "Pink Watermelon",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dwf1f18944/crop/026410629_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "",
    category1: "Concentrated Room Spray",
    Amount: 8.5,
    Rating: 5,
    desc: "What it smells like: standing in the middle of a lilac field on a cool spring morning. Fragrance notes: lilac bouquets, dewy greens and soft spring air.",
    height: 400,
    width: 150,
  },
  {
    id: "AtRS15",
    name: "Raspberries & Whipped Vanilla",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw379e5935/crop/026465839_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "",
    category1: "Concentrated Room Spray",
    Amount: 8.5,
    Rating: 9,
    desc: "What it smells like: standing in the middle of a lilac field on a cool spring morning. Fragrance notes: lilac bouquets, dewy greens and soft spring air.",
    height: 400,
    width: 150,
  },
  {
    id: "AtRS16",
    name: "Fresh Spring Morning",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw7f246337/crop/026410610_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "",
    category1: "Concentrated Room Spray",
    Amount: 8.5,
    Rating: 4,
    desc: "What it smells like: standing in the middle of a lilac field on a cool spring morning. Fragrance notes: lilac bouquets, dewy greens and soft spring air.",
    height: 400,
    width: 150,
  },
  {
    id: "AtRS17",
    name: "Japanese Cherry Blossom",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dwd69f97e3/crop/026302262_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "",
    category1: "Concentrated Room Spray",
    Amount: 8.5,
    Rating: 16,
    desc: "What it smells like: standing in the middle of a lilac field on a cool spring morning. Fragrance notes: lilac bouquets, dewy greens and soft spring air.",
    height: 400,
    width: 150,
  },
  {
    id: "AtRS18",
    name: "Iced Coconut Milk",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw35981831/crop/026410378_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "",
    category1: "Concentrated Room Spray",
    Amount: 8.5,
    Rating: 7,
    desc: "What it smells like: standing in the middle of a lilac field on a cool spring morning. Fragrance notes: lilac bouquets, dewy greens and soft spring air.",
    height: 400,
    width: 150,
  },
  {
    id: "AtRS19",
    name: "Eucalyptus Mint",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dwe882b305/crop/026302257_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "",
    category1: "Concentrated Room Spray",
    Amount: 8.5,
    Rating: 10,
    desc: "What it smells like: standing in the middle of a lilac field on a cool spring morning. Fragrance notes: lilac bouquets, dewy greens and soft spring air.",
    height: 400,
    width: 150,
  },
  {
    id: "AtRS20",
    name: "Strawberry Pound Cake",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw8c6ef1eb/crop/026302265_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "",
    category1: "Concentrated Room Spray",
    Amount: 8.5,
    Rating: 73,
    desc: "What it smells like: standing in the middle of a lilac field on a cool spring morning. Fragrance notes: lilac bouquets, dewy greens and soft spring air.",
    height: 400,
    width: 150,
  },
];

export const carFragrance = [
  {
    id: "AtCF1",
    name: "Endless Weekend",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dwfa053575/crop/026440730_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "",
    category1: "Car Fragrance Refill",
    Amount: 4.5,
    Rating: 103,
    desc: "What it smells like: standing in the middle of a lilac field on a cool spring morning. Fragrance notes: lilac bouquets, dewy greens and soft spring air.",
    height: 220,
    width: 230,
  },
  {
    id: "AtCF2",
    name: "Orange Pineapple Punch",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw9969fe0b/crop/026518379_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "",
    category1: "Car Fragrance Refill",
    Amount: 4.5,
    Rating: 10,
    desc: "What it smells like: standing in the middle of a lilac field on a cool spring morning. Fragrance notes: lilac bouquets, dewy greens and soft spring air.",
    height: 220,
    width: 230,
  },
  {
    id: "AtCF3",
    name: "Tiki Beach",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw540abb39/crop/026440734_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "",
    category1: "Car Fragrance Refill",
    Amount: 4.5,
    Rating: 101,
    desc: "What it smells like: standing in the middle of a lilac field on a cool spring morning. Fragrance notes: lilac bouquets, dewy greens and soft spring air.",
    height: 220,
    width: 230,
  },
  {
    id: "AtCF4",
    name: "Renew & Refresh",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw39ea607f/crop/026440740_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "",
    category1: "Car Fragrance Refill",
    Amount: 4.5,
    Rating: 9,
    desc: "What it smells like: standing in the middle of a lilac field on a cool spring morning. Fragrance notes: lilac bouquets, dewy greens and soft spring air.",
    height: 220,
    width: 230,
  },
  {
    id: "AtCF5",
    name: "Watermelon Lemonade",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw112ed198/crop/026440735_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "New!",
    category1: "Car Fragrance Refill",
    Amount: 4.5,
    Rating: 4,
    desc: "What it smells like: standing in the middle of a lilac field on a cool spring morning. Fragrance notes: lilac bouquets, dewy greens and soft spring air.",
    height: 220,
    width: 230,
  },
  {
    id: "AtCF6",
    name: "Cactus Blossom",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw00a222ea/crop/026440733_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "",
    category1: "Car Fragrance Refill",
    Amount: 4.5,
    Rating: 78,
    desc: "What it smells like: standing in the middle of a lilac field on a cool spring morning. Fragrance notes: lilac bouquets, dewy greens and soft spring air.",
    height: 220,
    width: 230,
  },
  {
    id: "AtCF7",
    name: "Black Cherry Merlot",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dwad5d53d4/crop/026440732_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "New!",
    category1: "Car Fragrance Refill",
    Amount: 4.5,
    Rating: 115,
    desc: "What it smells like: standing in the middle of a lilac field on a cool spring morning. Fragrance notes: lilac bouquets, dewy greens and soft spring air.",
    height: 220,
    width: 230,
  },
  {
    id: "AtCF8",
    name: "Strawberry Pound Cake",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw80e9d8dd/crop/026440739_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "",
    category1: "Car Fragrance Refill",
    Amount: 4.5,
    Rating: 9,
    desc: "What it smells like: standing in the middle of a lilac field on a cool spring morning. Fragrance notes: lilac bouquets, dewy greens and soft spring air.",
    height: 220,
    width: 230,
  },
  {
    id: "AtCF9",
    name: "Gemstone Butterfly Visor Clip",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw7883c9ee/crop/026424384_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "New!",
    category1: "Car Fragrance Refill",
    Amount: 9.5,
    Rating: 9,
    desc: "What it smells like: standing in the middle of a lilac field on a cool spring morning. Fragrance notes: lilac bouquets, dewy greens and soft spring air.",
    height: 220,
    width: 230,
  },
  {
    id: "AtCF10",
    name: "Sun-Drenched Linen",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dwa33cbf51/crop/026408262_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "",
    category1: "Car Fragrance Refill",
    Amount: 4.5,
    Rating: 1,
    desc: "What it smells like: standing in the middle of a lilac field on a cool spring morning. Fragrance notes: lilac bouquets, dewy greens and soft spring air.",
    height: 220,
    width: 230,
  },
  {
    id: "AtCF11",
    name: "Llama Succulent Visor Clip",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dwccdc412c/crop/026424382_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "",
    category1: "Car Fragrance Refill",
    Amount: 9.5,
    Rating: 1,
    desc: "What it smells like: standing in the middle of a lilac field on a cool spring morning. Fragrance notes: lilac bouquets, dewy greens and soft spring air.",
    height: 220,
    width: 230,
  },
  {
    id: "AtCF12",
    name: "Flower Visor & Vent Clip",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw30aea154/crop/026424388_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "New!",
    category1: "Car Fragrance Refill",
    Amount: 9.5,
    Rating: 4,
    desc: "What it smells like: standing in the middle of a lilac field on a cool spring morning. Fragrance notes: lilac bouquets, dewy greens and soft spring air.",
    height: 220,
    width: 230,
  },
  {
    id: "AtCF13",
    name: "Gemstone Strawberries Visor Clip",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw899d1f1b/crop/026434248_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "",
    category1: "Car Fragrance Refill",
    Amount: 9.5,
    Rating: 2,
    desc: "What it smells like: standing in the middle of a lilac field on a cool spring morning. Fragrance notes: lilac bouquets, dewy greens and soft spring air.",
    height: 220,
    width: 230,
  },
  {
    id: "AtCF14",
    name: "Aloha Kiwi Passionfruit",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dwcbf5f61e/crop/026408257_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "",
    category1: "Car Fragrance Refill",
    Amount: 4.5,
    Rating: 32,
    desc: "What it smells like: standing in the middle of a lilac field on a cool spring morning. Fragrance notes: lilac bouquets, dewy greens and soft spring air.",
    height: 220,
    width: 230,
  },
  {
    id: "AtCF15",
    name: "Pearl & Gems Visor & Vent Clip",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw4c1bc41a/crop/026439407_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "",
    category1: "Car Fragrance Refill",
    Amount: 8.5,
    Rating: 1,
    desc: "What it smells like: standing in the middle of a lilac field on a cool spring morning. Fragrance notes: lilac bouquets, dewy greens and soft spring air.",
    height: 220,
    width: 230,
  },
  {
    id: "AtCF16",
    name: "Pearl Turtle Visor & Vent Clip",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw175e3a3b/crop/026426667_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "",
    category1: "Car Fragrance Refill",
    Amount: 9.5,
    Rating: 2,
    desc: "What it smells like: standing in the middle of a lilac field on a cool spring morning. Fragrance notes: lilac bouquets, dewy greens and soft spring air.",
    height: 220,
    width: 230,
  },
  {
    id: "AtCF17",
    name: "Pineapple Visor Clip",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dwfbc9be58/crop/026424390_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "",
    category1: "Car Fragrance Refill",
    Amount: 9.5,
    Rating: 4,
    desc: "What it smells like: standing in the middle of a lilac field on a cool spring morning. Fragrance notes: lilac bouquets, dewy greens and soft spring air.",
    height: "220px",
    width: "230px",
  },
  {
    id: "AtCF18",
    name: "French Bulldog Visor Clip",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw140000f6/crop/026426669_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "",
    category1: "Car Fragrance Refill",
    Amount: 9.5,
    Rating: 2,
    desc: "What it smells like: standing in the middle of a lilac field on a cool spring morning. Fragrance notes: lilac bouquets, dewy greens and soft spring air.",
    height: "220px",
    width: "230px",
  },
  {
    id: "AtCF19",
    name: "Sunburst Visor Clip",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw2c3f8e5a/crop/026426679_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "",
    category1: "Car Fragrance Refill",
    Amount: 8.5,
    Rating: 1,
    desc: "What it smells like: standing in the middle of a lilac field on a cool spring morning. Fragrance notes: lilac bouquets, dewy greens and soft spring air.",
    height: "220px",
    width: "230px",
  },
  {
    id: "AtCF20",
    name: "Cactus Visor Clip",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw7ef9c9d0/crop/026449026_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "",
    category1: "Car Fragrance Refill",
    Amount: 4.5,
    Rating: 2,
    desc: "What it smells like: standing in the middle of a lilac field on a cool spring morning. Fragrance notes: lilac bouquets, dewy greens and soft spring air.",
    height: "220px",
    width: "230px",
  },
];

export const newFragrance = [
  {
    id: "AtNF1",
    name: "Paradise Cove",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dwcc92eb7f/crop/026476584_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "Just Added!",
    category1: "3-Wick Candle",
    Amount: 26.5,
    Rating: 11,
    desc: "What it smells like: standing in the middle of a lilac field on a cool spring morning. Fragrance notes: lilac bouquets, dewy greens and soft spring air.",
    height: 320,
    width: 200,
  },
  {
    id: "AtNF2",
    name: "Puffer Fish Pedestal",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw9b3a4110/hires/026488706_alt_1.jpg?sh=413&yocs=o_s_",
    category: "New!",
    category1: "3-Wick Candle Holder",
    Amount: 39.95,
    Rating: 3,
    desc: "What it smells like: standing in the middle of a lilac field on a cool spring morning. Fragrance notes: lilac bouquets, dewy greens and soft spring air.",
    height: 320,
    width: 200,
  },
  {
    id: "AtNF3",
    name: "Sea Salt & Lime",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dwb49f9f5b/crop/026468311_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "New!",
    category1: "Gentle Foaming Hand Soap",
    Amount: 7.5,
    Rating: 1,
    desc: "What it smells like: standing in the middle of a lilac field on a cool spring morning. Fragrance notes: lilac bouquets, dewy greens and soft spring air.",
    height: 320,
    width: 190,
  },
  {
    id: "AtNF4",
    name: "Pink Lemonade",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw8d9f4f02/crop/026482400_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "New Fragrance!",
    category1: "Single Wick Candle",
    Amount: 15.5,
    Rating: 4,
    desc: "What it smells like: standing in the middle of a lilac field on a cool spring morning. Fragrance notes: lilac bouquets, dewy greens and soft spring air.",
    height: 320,
    width: 200,
  },
  {
    id: "AtNF5",
    name: "Butterfly",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw54c12225/crop/026439201_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "Just Added!",
    category1: "Gentle Foaming Hand Soap",
    Amount: 7.5,
    Rating: 8,
    desc: "What it smells like: standing in the middle of a lilac field on a cool spring morning. Fragrance notes: lilac bouquets, dewy greens and soft spring air.",
    height: 320,
    width: 190,
  },
  {
    id: "AtNF6",
    name: "Butterfly",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw0f97819c/crop/026473987_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "new!",
    category1: "3-Wick Candle",
    Amount: 26.5,
    Rating: 24,
    desc: "What it smells like: standing in the middle of a lilac field on a cool spring morning. Fragrance notes: lilac bouquets, dewy greens and soft spring air.",
    height: 320,
    width: 200,
  },
  {
    id: "AtNF7",
    name: "Island Punch",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw04740286/crop/026487386_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "Just Added",
    category1: "Gentle Foaming Hand Soap",
    Amount: 7.5,
    Rating: 1,
    desc: "What it smells like: standing in the middle of a lilac field on a cool spring morning. Fragrance notes: lilac bouquets, dewy greens and soft spring air.",
    height: 320,
    width: 190,
  },
  {
    id: "AtNF25",
    name: "Eucalyptus Spearmint",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dwf1c3d3c5/crop/026397334_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "Just Added!",
    category1: "Wallflowers Fragrance Refill",
    Amount: 7.5,
    Rating: 11,
    desc: "What it smells like: standing in the middle of a lilac field on a cool spring morning. Fragrance notes: lilac bouquets, dewy greens and soft spring air.",
    height: 320,
    width: 190,
  },
  {
    id: "AtNF8",
    name: "SUNSHINE & LEMONS",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw6d5e64ca/crop/026490034_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "New Fragrance!",
    category1: "Gentle Foaming Hand Soap",
    Amount: 7.5,
    Rating: 1,
    desc: "What it smells like: standing in the middle of a lilac field on a cool spring morning. Fragrance notes: lilac bouquets, dewy greens and soft spring air.",
    height: 320,
    width: 190,
  },
  {
    id: "AtNF9",
    name: "Wildberry Lemonade",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw0a270a6e/crop/026487394_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "New!",
    category1: "Gentle Foaming Hand Soap",
    Amount: 7.5,
    Rating: 1,
    desc: "What it smells like: standing in the middle of a lilac field on a cool spring morning. Fragrance notes: lilac bouquets, dewy greens and soft spring air.",
    height: 320,
    width: 190,
  },
  {
    id: "AtNF10",
    name: "Boardwalk Vanilla Cone",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw6d1ecec6/crop/026490031_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "Just Added!",
    category1: "Gentle Foaming Hand Soap",
    Amount: 7.5,
    Rating: 2,
    desc: "What it smells like: standing in the middle of a lilac field on a cool spring morning. Fragrance notes: lilac bouquets, dewy greens and soft spring air.",
    height: 320,
    width: 190,
  },
  {
    id: "AtC5",
    name: "Coastal Watermelon",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw9f23f750/crop/026482403_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "",
    category1: "Single Wick Candle",
    Amount: 15.5,
    Rating: 2,
    desc: "What it smells like: standing in the middle of a lilac field on a cool spring morning. Fragrance notes: lilac bouquets, dewy greens and soft spring air.",
    height: 320,
    width: 190,
  },
  {
    id: "AtNF11",
    name: "Turquoise Waters",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dwa18f08e2/crop/026490033_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "New Fragrance!",
    category1: "Gentle Foaming Hand Soap",
    Amount: 7.5,
    Rating: 1,
    desc: "What it smells like: standing in the middle of a lilac field on a cool spring morning. Fragrance notes: lilac bouquets, dewy greens and soft spring air.",
    height: 320,
    width: 200,
  },
  {
    id: "AtNF12",
    name: "Endless Weekend",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dwff43fe31/crop/026487391_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "New!",
    category1: "Gentle Foaming Hand Soap",
    Amount: 7.5,
    Rating: 1,
    desc: "What it smells like: standing in the middle of a lilac field on a cool spring morning. Fragrance notes: lilac bouquets, dewy greens and soft spring air.",
    height: 320,
    width: 190,
  },
  {
    id: "AtNF13",
    name: "Oceanfront Garden",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dwf0f64f42/crop/026490035_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "Just Adde!",
    category1: "Gentle Foaming Hand Soap",
    Amount: 7.5,
    Rating: 1,
    desc: "What it smells like: standing in the middle of a lilac field on a cool spring morning. Fragrance notes: lilac bouquets, dewy greens and soft spring air.",
    height: 320,
    width: 190,
  },
  {
    id: "AtNF14",
    name: "Sunny Squeeze",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw0fdde25d/crop/026495972_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "",
    category1: "Gentle Foaming Hand Soap",
    Amount: 7.5,
    Rating: 1,
    desc: "What it smells like: standing in the middle of a lilac field on a cool spring morning. Fragrance notes: lilac bouquets, dewy greens and soft spring air.",
    height: 320,
    width: 190,
  },
  {
    id: "AtNF15",
    name: "Berry Waffle Cone",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw2f53c870/crop/026487385_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "New Fragrance!",
    category1: "Gentle Foaming Hand Soap",
    Amount: 7.5,
    Rating: 1,
    desc: "What it smells like: standing in the middle of a lilac field on a cool spring morning. Fragrance notes: lilac bouquets, dewy greens and soft spring air.",
    height: 320,
    width: 190,
  },
  {
    id: "AtNF16",
    name: "Bright Summer Days",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dwd3b9cb05/crop/026490036_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "",
    category1: "Gentle Foaming Hand Soap",
    Amount: 7.5,
    Rating: 2,
    desc: "What it smells like: standing in the middle of a lilac field on a cool spring morning. Fragrance notes: lilac bouquets, dewy greens and soft spring air.",
    height: 320,
    width: 190,
  },
  {
    id: "AtC11",
    name: "The Perfect Summer",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw02c8940e/crop/026517154_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "",
    category1: "Single Wick Candle",
    Amount: 15.5,
    Rating: 5,
    desc: "What it smells like: standing in the middle of a lilac field on a cool spring morning. Fragrance notes: lilac bouquets, dewy greens and soft spring air.",
    height: 320,
    width: 200,
  },
  {
    id: "AtNF17",
    name: "Watermelon Lemonade",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dwc1671a68/crop/026474053_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "",
    category1: "Gentle Gel Hand Soap",
    Amount: 7.5,
    Rating: 2,
    desc: "What it smells like: standing in the middle of a lilac field on a cool spring morning. Fragrance notes: lilac bouquets, dewy greens and soft spring air.",
    height: 320,
    width: 200,
  },
  {
    id: "AtNF18",
    name: "Tulip Gardens",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dwc7ed5e1a/crop/026439710_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "",
    category1: "Gentle Foaming Hand Soap",
    Amount: 7.5,
    Rating: 11,
    desc: "What it smells like: standing in the middle of a lilac field on a cool spring morning. Fragrance notes: lilac bouquets, dewy greens and soft spring air.",
    height: 320,
    width: 200,
  },
  {
    id: "AtNF19",
    name: "Sea Salt & Lime",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw632f0f2e/crop/026470439_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "",
    category1: "Gentle Gel Hand Soap",
    Amount: 7.5,
    Rating: 1,
    desc: "What it smells like: standing in the middle of a lilac field on a cool spring morning. Fragrance notes: lilac bouquets, dewy greens and soft spring air.",
    height: 320,
    width: 200,
  },
  {
    id: "AtNF20",
    name: "Sweet Orange Blossom",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dwa24f152e/crop/026474057_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "",
    category1: "Gentle Gel Hand Soap",
    Amount: 7.5,
    Rating: 1,
    desc: "What it smells like: standing in the middle of a lilac field on a cool spring morning. Fragrance notes: lilac bouquets, dewy greens and soft spring air.",
    height: 320,
    width: 200,
  },
  {
    id: "AtNF21",
    name: "Lakeside Afternoon",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dwd9b51dce/crop/026474055_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "",
    category1: "Gentle Gel Hand Soap",
    Amount: 7.5,
    Rating: 1,
    desc: "What it smells like: standing in the middle of a lilac field on a cool spring morning. Fragrance notes: lilac bouquets, dewy greens and soft spring air.",
    height: 320,
    width: 200,
  },
  {
    id: "AtNF22",
    name: "White Tea & Sage",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dwe54dee11/crop/026460679_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "",
    category1: "Gentle Gel Hand Soap",
    Amount: 7.5,
    Rating: 1,
    desc: "What it smells like: standing in the middle of a lilac field on a cool spring morning. Fragrance notes: lilac bouquets, dewy greens and soft spring air.",
    height: 320,
    width: 200,
  },
  {
    id: "AtCC12",
    name: "Iced Lemon Pound Cake",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw536b669c/crop/026480791_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "",
    category1: "Single Wick Candle",
    Amount: 15.5,
    Rating: 19,
    desc: "What it smells like: standing in the middle of a lilac field on a cool spring morning. Fragrance notes: lilac bouquets, dewy greens and soft spring air.",
    height: 320,
    width: 200,
  },
  {
    id: "AtNF23",
    name: "Strawberry Pound Cake",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dwe8ae5215/crop/026438945_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "",
    category1: "Gentle Foaming Hand Soap",
    Amount: 7.5,
    Rating: 3,
    desc: "What it smells like: standing in the middle of a lilac field on a cool spring morning. Fragrance notes: lilac bouquets, dewy greens and soft spring air.",
    height: 320,
    width: 200,
  },
  {
    id: "AtNF24",
    name: "Crisp Apple",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw93af10f3/crop/026461146_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "",
    category1: "Gentle Foaming Hand Soap",
    Amount: 7.5,
    Rating: 4,
    desc: "What it smells like: standing in the middle of a lilac field on a cool spring morning. Fragrance notes: lilac bouquets, dewy greens and soft spring air.",
    height: 320,
    width: 200,
  },
];
